
// Definición de defaults

export const defaultUnidad: UnidadProps = {
    idUnidad:       0,
    descripcion:    '',
    activo:         false,
};

// Creación de interfaces

export interface UnidadProps{
    idUnidad:       number;
    descripcion:    string;
    activo:         boolean;
}